import { AddressList } from "./AddressList";

export default AddressList;